/**
 * Collection Metafield Sections — Shared JS
 * Handles scroll-reveal animations and FAQ accordion
 */
(function () {
  'use strict';

  /* ── Scroll Reveal ─────────────────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.cm-reveal');
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cm-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      els.forEach(function (el) { observer.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('cm-visible'); });
    }
  }

  /* ── FAQ Accordion ─────────────────────────────────────────────────── */
  function initFaq() {
    var btns = document.querySelectorAll('.cm-faq-btn');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.cm-faq-item');
        var answer = item.querySelector('.cm-faq-answer');
        var isOpen = item.classList.contains('cm-open');

        // Close all
        btns.forEach(function (b) {
          var pi = b.closest('.cm-faq-item');
          pi.classList.remove('cm-open');
          b.setAttribute('aria-expanded', 'false');
          var pa = pi.querySelector('.cm-faq-answer');
          if (pa) pa.setAttribute('aria-hidden', 'true');
        });

        // Toggle current
        if (!isOpen) {
          item.classList.add('cm-open');
          btn.setAttribute('aria-expanded', 'true');
          if (answer) answer.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  /* ── Init ───────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initFaq();
    });
  } else {
    initReveal();
    initFaq();
  }
})();
